import Tooltip from "components/Tools/Tooltip";
import { ICON_COLORS } from "components/Constants/constants";
import { classNames } from "tools/ui";
import {
  ArrowLeftIcon,
  PencilSquareIcon,
  SaveIcon,
  TrashIcon,
  PlusCircleIcon,
} from "components/Icons";

const classes =
  "group relative flex my-auto h-10 w-10 cursor-pointer rounded-xl py-1 px-2 text-xl items-center text-center hover:opacity-90 disabled:opacity-50 justify-center gap-2 active:scale-95";
const BTN_STYLE = "flex text-2xl my-auto fill-current";

function IconButton({ name, size, style, color, disabled, onClick, tooltip }) {
  async function handleClick(e) {
    if (disabled) return;
    e.preventDefault();
    await onClick(e, name);
  }

  let _size = "w-12";
  if (size) {
    _size = size;
  }

  const [bgColor, iconColor] = ICON_COLORS[color];

  const Icons = {
    button_back: {
      icon: (
        <ArrowLeftIcon
          key={name}
          className={classNames(BTN_STYLE, name, iconColor)}
        />
      ),
    },
    button_edit: {
      icon: (
        <PencilSquareIcon
          key={name}
          className={classNames(BTN_STYLE, name, iconColor)}
        />
      ),
    },
    button_save: {
      icon: (
        <SaveIcon
          key={name}
          className={classNames(BTN_STYLE, name, iconColor)}
        />
      ),
    },
    button_delete: {
      icon: (
        <TrashIcon
          key={name}
          className={classNames(BTN_STYLE, name, iconColor)}
        />
      ),
    },
    button_add: {
      icon: (
        <PlusCircleIcon
          key={name}
          className={classNames(BTN_STYLE, name, iconColor)}
        />
      ),
    },
  };

  const selectedIcon = Icons[name]?.icon || Icons["button_back"]?.icon;

  return (
    <div
      onClick={(e) => handleClick(e)}
      className={classNames(style, _size, bgColor, classes)}
      disabled={disabled ?? false}
    >
      {selectedIcon}
      {tooltip && <Tooltip tooltip={tooltip} />}
    </div>
  );
}

export default IconButton;
